var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyWrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4472 2.51807C12.9023 2.31712 12.3008 2.60941 12.1055 3.17076C11.9101 3.73211 12.1943 4.34992 12.74 4.55088C15.7174 5.64783 17.7172 8.57081 17.7172 11.8251C17.7172 16.0842 14.3482 19.5494 10.2074 19.5494C6.06666 19.5494 2.69768 16.0842 2.69768 11.8251C2.69768 9.9011 3.38956 8.0568 4.64657 6.63433C5.62344 5.52825 6.87641 4.74768 8.25532 4.36653V5.44687C8.25532 5.55731 8.37642 5.62208 8.46442 5.55814L11.5121 3.33684C11.5864 3.28286 11.5864 3.1691 11.5121 3.11512L8.46442 0.893822C8.37642 0.829882 8.25532 0.893822 8.25532 1.00509V2.14772C6.27576 2.56873 4.46896 3.62416 3.09247 5.1828C1.48427 7.00386 0.598633 9.36301 0.598633 11.826C0.598633 17.2758 4.90895 21.7093 10.2074 21.7093C15.5059 21.7093 19.8162 17.2758 19.8162 11.826C19.8162 7.66236 17.257 3.92227 13.4472 2.5189V2.51807Z",
    fill: "#757373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyWrap);
export default __webpack_public_path__ + "static/media/greyWrap.d0d3cbe2d648000c24d951d6e072be66.svg";
export { ForwardRef as ReactComponent };